import './AccessStatisticsSection.scss';
import { NoData } from '@ui/NoData';
import { SonarText } from '@ui/text';
import { COPY_SPECIFIC, DATA_SECURITY_DASHBOARD } from '@sonar-software/sonar-ts-constants';
import React from 'react';
const sectionLabels = {
    applications: COPY_SPECIFIC.APPLICATIONS,
    entities: COPY_SPECIFIC.ENTITIES,
    fields: COPY_SPECIFIC.FIELDS
};
export const AccessStatisticsSection = ({ children, hide, isEmpty, section }) => {
    if (hide) {
        return null;
    }
    const countSource = section === 'applications' ? DATA_SECURITY_DASHBOARD.CALLS : DATA_SECURITY_DASHBOARD.REQUESTS;
    const topFiveRequests = `Top 5 ${sectionLabels[section]} by ${countSource}`;
    return (React.createElement("div", { className: 'access-statistics-section' },
        React.createElement(SonarText, { className: 'top-five-title', weight: 'semibold' }, topFiveRequests),
        React.createElement("div", { className: 'column-headers' },
            React.createElement(SonarText, { weight: 'semibold' }, sectionLabels[section]),
            React.createElement(SonarText, { weight: 'semibold' }, countSource)),
        React.createElement("div", { className: 'statistics-rows' }, isEmpty ? React.createElement(NoData, null) : children)));
};
